// JsFromRoutes CacheKey 08808d9a31b34e113de5356d3339c331
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/landing_page_text_modules/search'),
  duplicate: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/landing_page_text_modules/:id/duplicate'),
  typeaheadSelect: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/landing_page_text_modules/typeahead_select'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/landing_page_text_modules'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/landing_page_text_modules'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/landing_page_text_modules/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/landing_page_text_modules/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/landing_page_text_modules/:id'),
}
